export const metatagilistaportali = {
  Page: {
    "meta-tagi": {
      Title:
        "SkiOne.pl - zarezerwuj najlepsze wczasy i wycieczki z TravelOne.pl. Mapa Świata wszystkich portali z Grupy TravelOne.pl.",
      Description:
        "Ponad 58 krajów, wszystkie portale w jednym miejscu. Oferty wczasów last minute i wycieczek objazdowych na Kanarach. Wakacje z dziećmi, hotele SPA, piękne plaże - wakacje All Inclusive na Wyspach Kanaryjskich. ::: Zaplanuj idealne wakacje z Grupą Portali TravelOne.pl!",
      Keywords: []
    }
  }
};
